import React from 'react';
import type { FC } from 'react';
import type { TView } from '@alfa-bank/site-text-v2/src/models';
import { BlockHolder } from '@alfa-bank/site-block-holder';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { BackgroundV2 as Background } from '@alfa-bank/site-background-v2';
import { Img } from '@alfa-bank/site-img';
import { Grid } from '@alfa-bank/site-grid-universal';

import type { TAdditionalProductField } from './models';

export const AdditionalProductField: FC<TAdditionalProductField> = ({
    BundleCheckbox,
    Text,
    defaultProducts,
    isFlexibleAlfaCard,
    isMobile,
    name,
    products,
    title,
}) => {
    const imageSize = isMobile ? 90 : 267;

    const desktopBlockMargin = isFlexibleAlfaCard ? 40 : 32;

    const getFlexibleDesignTextView = (): TView | undefined => {
        if (isFlexibleAlfaCard) {
            return isMobile ? 'xsmall' : 'small';
        }

        return undefined;
    };

    return (
        <>
            <Text
                styler={{
                    margin: 0,
                    padding: 0,
                    paddingTop: isMobile || isFlexibleAlfaCard ? 0 : 12,
                    paddingBottom: !isMobile && isFlexibleAlfaCard ? 24 : 16,
                }}
                view={getFlexibleDesignTextView()}
            >
                {title}
            </Text>
            <Block
                notPadded
                overflowHidden
                styler={{ borderRadius: 16, marginBottom: isMobile ? 24 : desktopBlockMargin }}
            >
                <Background
                    color={products[0].backgroundColor}
                    dataTestId="dc-form-additional-products-single"
                    image={products[0].backgroundImage}
                >
                    <Grid
                        collapse
                        columnsMargin={0}
                        columnsWidth={[isMobile ? 'auto' : 251, imageSize]}
                        justify="between"
                    >
                        <BundleCheckbox
                            {...products[0]}
                            additionalProducts={products[0].value}
                            initialValue={defaultProducts}
                            name={name}
                            styler={{
                                paddingLeft: 16,
                                paddingTop: 16,
                                paddingBottom: 16,
                            }}
                        />
                        <BlockHolder
                            height="100%"
                            styler={isMobile ? undefined : { marginRight: 24 }}
                            width={`${imageSize}px`}
                        >
                            <Img height="100%" src={products[0].image} width={imageSize} />
                        </BlockHolder>
                    </Grid>
                </Background>
            </Block>
        </>
    );
};
